/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=4bd1b3d9&"
import script from "./listItem.vue?vue&type=script&lang=js&"
export * from "./listItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports